export const BREAKPOINTS = {
    overlay: {
        sm: 390,
        md: 768,
        lg: 1024,
        xl: 1280,
    },
    embedded: {
        sm: 360,
        md: 720,
        lg: 720,
    },
};
export const BREAKPOINTS_HEIGHTS = {
    overlay: {
        lg: 768,
    },
    embedded: {
        sm: 360,
    },
};
